'use client'

import { usePathname } from 'next/navigation'

const CHROMELESS_PATH_PREFIXES = ['/compare/', '/best/']

interface ChromeGateProps {
  children: React.ReactNode
}

/**
 * Hides the site chrome on chromeless routes. Client island for the pathname
 * check only — the navbar and footer passed as children stay server-rendered.
 */
export function ChromeGate({ children }: ChromeGateProps) {
  const pathname = usePathname()
  const chromeless = pathname
    ? CHROMELESS_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))
    : false
  if (chromeless) return null
  return <>{children}</>
}
